import { Component, Inject, Input } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { EntityCheckboxListComponent } from '../../../../shared/checkbox-list/components/entity-checkbox-list.component';

import { OuvrageService } from '../services/ouvrage.service';
import { OuvrageTLR } from '../entities/ouvrage-tlr.entity';

@Component({
	selector: 'ouvrage-checkbox-list',
	templateUrl: '../../../../shared/checkbox-list/components/entity-checkbox-list.html',
	styleUrls: ['../../../../shared/checkbox-list/components/entity-checkbox-list.css']
})
export class OuvrageCheckboxListComponent extends EntityCheckboxListComponent<OuvrageTLR> {
	// Ids des parcs dont les ouvrages doivent etre affiches comme options
	_parcIds: number[] = [];
	@Input() set parcIds(ids: number[] | undefined) {
		if (ids != undefined && ids != this._parcIds) {
			this._parcIds = ids;
			this.updateOuvrages();
		}
	}
	
	// Observable des sous-parcs pour lesquels l'utilisateur commande la deselection des ouvrages
	@Input() set sousParcDeselectionRequests(obs: Observable<number>) {
		this.deselectionsSubject = obs.pipe(
			map (
				(sousParcId) => (item: OuvrageTLR) => item.sousParcId === sousParcId
			)
		)
	}
	
	// Titre du champ
	override label = "Ouvrage(s)"
	
	// Fonction determinant le label d'un ouvrage
	override getEntityLabel = (ouvrage: OuvrageTLR) => ouvrage.nom;
	
	// Fonction determinant le tooltip d'un ouvrage
	override getEntityTitle = (ouvrage: OuvrageTLR) => ouvrage.description;

	constructor( //
		@Inject(OuvrageService) private ouvrageService: OuvrageService //
	) {
		super();
	}
	
	private updateOuvrages() {
		if (this._parcIds && this._parcIds.length > 0) {
			this.ouvrageService.getOuvrageTLRMapByParc().subscribe(
				(map: Map<number, OuvrageTLR[]>) => {
					
					// Pour chaque parc selectionne, ajouer ses ouvrages a la liste a afficher
					let ouvrages: OuvrageTLR[] = [];
					for (let i = 0; i <= this._parcIds.length; i++) {
						let parcId = this._parcIds[i];
						let list = map.get(parcId);
						if (list) {
							ouvrages = ouvrages.concat(list);
						}
					}
					
					// Trier ensuite tous les ouvrages par leur code
					ouvrages.sort(
						(o1, o2) => o1.nom.localeCompare(o2.nom) 
					);
					
					this.entities = ouvrages;
				}
			);
		} else {
			this.entities = [];
		}
	}
}